import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "bb_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40 bg-espresso text-bone rounded-2xl p-5 shadow-xl"
          data-testid="cookie-consent"
        >
          <p className="text-sm leading-relaxed text-bone/85">
            We use cookies to remember your cart, improve your experience and process orders. We never sell your data.{" "}
            <Link to="/policies/cookies" className="underline text-bone hover:text-terracotta" data-testid="cookie-learn-more">
              Learn more
            </Link>
            .
          </p>
          <div className="flex gap-3 mt-4">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="bg-terracotta text-bone px-5 py-2 rounded-full text-sm font-medium hover:bg-bone hover:text-espresso transition-colors"
            >
              Accept
            </button>
            <Link
              to="/policies/cookies"
              className="px-5 py-2 rounded-full text-sm font-medium border border-bone/30 text-bone/90 hover:bg-white/10 transition-colors"
            >
              Preferences
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
